<template>
  <div class="docsetting">
    <div class="list">
      <van-cell >
        <div class="container">
          <div class="upload-button" @click="showAddDoc">
            <img src="/static/images/program/updata.png" alt="Upload" class="upload-icon">
          </div>
          <div class="scrollable-list">
            <div class="list-item" v-for="(item, index) in lists" :key="index">
              <div class="delete-button" @click="dele(index)">
                <img src="/static/images/program/del.png">
              </div>
              <div class="image-container">
                <img :src="getDocUrl(item)" class="item-image">
                <div class="scrolling-text">
                  <span>{{ item.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-cell>
    </div>
    <addDoc v-if="isDoc" @setDoc="getDoc" @close="close"></addDoc>
  </div>

</template>

<script>
import {mapActions, mapState} from 'vuex'
import addDoc from "@/components/addDoc.vue";
import {Toast} from "vant";
import {getFileSuffix} from "../utils";

  export default {
    components: {addDoc},
    props: {
      lists: {
        type: Array,
        default: () => {
          return []
        }
      },
    },
    data() {
      return {
        isDoc: false,
      }
    },
    mounted() {
    },
    methods: {
      ...mapActions(['addDoc']),
      dele(index) {
        this.$emit('ondele', index)
      },
      showAddDoc() {
        if(this.lists !='' ){
          Toast(this.$t('append_field.oneDoc'))
          return
        }
        this.isDoc = true
      },
      getDoc(data) {
        this.addDoc(data)
        this.isDoc = false
      },
      close() {
        this.isDoc = false
      },
      clear() {
        this.$emit('clear')
      },
      getDocUrl(item) {
        if (item && item.url) {
          const suffix = '.' + getFileSuffix(item.name)
          const pptExt = ['.ppt', '.pptx', '.pot', '.potx', '.pps', '.ppsx', '.dps', '.dpt', '.pptm', '.potm', '.ppsm', '.dpss']
          const wordExt = ['.doc', '.docx', '.wps', '.wpss', '.docm', '.dotm', '.dot', '.dotx', '.html']

          if (suffix === '.pdf') {
            return  '/static/images/program/pdf.png'
          } else if (suffix === '.xlsx' || suffix === '.xls') {
            return  '/static/images/program/xlsx.png'
          } else if (pptExt.includes(suffix)) {
            return  '/static/images/program/ppt.png'
          } else if (suffix === '.txt') {
            return  '/static/images/program/txt.png'
          } else if (wordExt.includes(suffix)) {
            return  '/static/images/program/word.png'
          }
        }
        // 如果 item 或 item.suffix 为空，返回一个默认图片或处理逻辑
        //return "/static/images/icon_loader_failed.png"
      }
    },
    computed: {
      ...mapState({
        controlIndex: state => state.controlIndex,
        componentsList: state => state.componentsList,
      }),
    },
  }
</script>

<style lang="scss">
  @import "../../public/static/css/app";
  .docsetting {
    /*border-top: 1px solid $uni-text-color-placeholder;*/
    .container {
      display: flex;
      //height:60px;
      width: 100%;
    }

    .upload-button {
      position: sticky;
      left: 0;
      top: 0;
      width: 40px;
      height: 40px;
      background-color: white; /* 防止内容滚动时覆盖 */
      padding: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .upload-icon {
      width: 65px;
      height: 65px;
    }

    .scrollable-list {
      width: calc(100% - 50px);
      display: flex;
      overflow-x: auto;
      margin-left: 10px; /* 为了避免与固定的上传按钮重叠 */
    }

    .delete-button {
      align-self: flex-end;
      cursor: pointer;
      position: absolute; /* 绝对定位 */
      z-index: 2;
      top: 2px; /* 距离顶部5px */
      right: 2px;
      img{
        width: 20px;
        height: 20px;
      }
    }
    .list-item {
      position: relative; /* 使得内部的绝对定位元素相对于该元素定位 */
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 10px;
      .image-container {
        position: relative;
        .item-image {
          width: 60px;
          height: 60px;
        }

        .scrolling-text {
          position: absolute;
          bottom: 7px;
          left: 0;
          width: 100%;
          background: rgba(0, 0, 0, 0.5);
          color: white;
          overflow: hidden;
          white-space: nowrap;
          box-sizing: border-box;
        }

        .scrolling-text span {
          display: inline-block;
          animation: scroll-text 10s linear infinite;
        }

        @keyframes scroll-text {
          0% {
            transform: translateX(60px);
          }
          100% {
            transform: translateX(-100%);
          }
        }
      }
    }

  }



</style>
